export enum RatingCriterion {
  Overall = 'overall',
  ItemAsDescribed = 'itemAsDescribed',
  ItemReturnCondition = 'itemReturnCondition',
  Punctuality = 'punctuality',
  Friendliness = 'friendliness'
}
